export default function (nga, admin, activities) {

    var properties = admin.getEntity('properties');
    properties.listView()
        .title('{{ "Properties" | translate }}')
        .fields([
            nga.field('name')
              .isDetailLink(true),
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .sortable(false)
                .label('Activity'),
            nga.field('position', 'number')
        ])
        .filters([
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .label('Activity'),
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
        ])
        .actions(['create', 'filter'])
        .listActions(['<ma-filtered-list-button entity-name="values" filter="{ property_id: entry.values.id }" size="xs"></ma-filtered-list-button>', 'edit']);
    properties.creationView()
        .fields([
            nga.field('name')
                .validation({ required: true }),
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .label('Activity')
                .validation({ required: true }),
            nga.field('position', 'number'),
            nga.field('', 'template')
                .label('')
                .editable(false)
                .template('<span class="pull-right"><ma-filtered-list-button entity-name="values" filter="{ property_id: entry.values.id }" size="sm"></ma-filtered-list-button></span>')

        ]);
    properties.editionView()
        .title('{{ "EDIT" | translate }}')
        .fields(properties.creationView().fields());

    return properties;
}



// WEBPACK FOOTER //
// ./js/properties/config.js